import React, { useEffect, useState } from 'react';
import { Col, Row, Tooltip, Select, Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';

import Modal from "../../components/uiComponent/modal/index";
import Input from '../../components/uiComponent/inputs/labelInput';
import ProductImg from "../../assets/images/newImages/nestle.svg";
import copyIcon from "../../assets/images/newImages/copy-white-icon.svg";

import InventoryWrapper from './style';
import { EditItemQuantity, updateMappedQuantity } from '../../slices/3-layer-products';
import { copyToClip } from '../../utils/utils';

const { Option } = Select;

const EditProductQtyModal = ({
  open,
  onHide,
  expandRow,
  skuData,
  productIndex,
  products,
  handleRefreshPageData,
  handleShowMappingAlert
}) => {
  const dispatch = useDispatch();

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [quantity, setQuantity] = useState("");

  const {
    editingItemQuantity
  } = useSelector((state) => state.threeLayerProducts || {});

  useEffect(() => {
    setSelectedProduct({ value: { key: productIndex, label: products[productIndex]?.identifier_value } });
    setQuantity(products[productIndex]?.product_sku_mappings_v2?.bundle_quantity);
  }, [products]);

  return (
    <Modal
      open={open}
      onHide={onHide}
      size="lg"
      closeText="Cancel"
      saveText="Confirm"
      header={true}
      closeButton={true}
      onClose={onHide}
      onSave={() => {
        dispatch(EditItemQuantity({
          sku_id: skuData.id,
          product_id: products[productIndex].id,
          quantity
        })).then(({ payload }) => {
          if (payload?.success) {
            dispatch(updateMappedQuantity({ field: 'skus', parentId: skuData.id, key: 'products_v2', childId: products[productIndex].id, value: quantity }));
            handleRefreshPageData(skuData.id)
            // expandRow(skuData.id);
            onHide();
          }
          else if (!isEmpty(payload?.errorData)) handleShowMappingAlert();
        });
      }}
      buttonDisabled={!quantity || quantity <= 0}
    >
      <InventoryWrapper className='sku-modal'>
        <Spin tip='Loading...' spinning={editingItemQuantity}>
          <h4 className='text-primary fw-bold mb-3'>Edit Mapping</h4>
          <div className="product-title mb-4">
            <img src={skuData.image_url || ProductImg} alt="product" width={28} height={28} className='product-img' />
            <div className='w-100'>
              <Tooltip placement="bottom" title={skuData.item_name}>
                <span className="product-name">{skuData.item_name}</span>
              </Tooltip>
              <div className='d-flex align-items-center gap-2'>
                <div className='asin'>
                  <span>ASIN <span>{skuData.asin}</span></span>
                  <img src={copyIcon} alt='copy' className='cursor-pointer'
                    onClick={() => copyToClip(skuData.asin)}
                  />
                </div>
                <div className='asin sku'>
                  <span>SKU <span>{skuData.sku}</span></span>
                  <img src={copyIcon} alt='copy' className='cursor-pointer'
                    onClick={() => copyToClip(skuData.sku)}
                  />
                </div>
              </div>
            </div>
          </div>
          <Row gutter={24} className='mb-5'>
            <Col span={11}>
              <div className='search-sku'>
                <label>Search Products</label>
                <Select
                  showSearch
                  placeholder="Select"
                  style={{ width: "100%" }}
                  value={selectedProduct?.value}
                  onChange={(value, option) => {
                    setSelectedProduct({ value, label: option.label });
                  }}
                  labelInValue
                  optionLabelProp="label"
                  getPopupContainer={(triggerNode) => triggerNode.parentElement}
                  disabled={true}
                >
                  {products.map((item, index) => (
                    <Option key={index} value={item.id} label={item.identifier_value}>
                      <div className="product-title option-product w-100">
                        <img src={item.image_url || ProductImg} alt="product" width={36} height={36} className='product-img' />
                        <div className='w-100'>
                          <Tooltip placement="bottom" title={item.item_name}>
                            <span className="product-name">{item.item_name}</span>
                          </Tooltip>
                          <div className='d-flex gap-2'>
                            <div className='asin'>
                              <span>{item.identifier_value}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Option>
                  ))}
                </Select>
              </div>
            </Col>
            <Col span={13}>
              <div className='d-flex align-items-end gap-3 add-sku-btn'>
                <Input
                  placeholder="Enter"
                  value={quantity}
                  type="number"
                  onChange={(e) => setQuantity(e.target.value)}
                  label="Quantity"
                  width="80%"
                  marginBottom="0"
                />
              </div>
            </Col>
          </Row>
        </Spin>
      </InventoryWrapper>
    </Modal>
  );
};

export default EditProductQtyModal;
